import isEmpty from "lodash/isEmpty"

export default function validateInput(data) {
  const lang_code = localStorage.getItem("lang")

  const lang_required = {
    fr: {
      message_required: `Ce champ est requis`,
    },
    en: {
      message_required: `This field is required`,
    },
    sw: {
      message_required: `Ni lazima kujaza nafasi hii`,
    },
    za: {
      message_required: `Tilas batamo hima ga bara`,
    },
    ha: {
      message_required: `Doole hilin ga shina nan`,
    },
    es: {
      message_required: `Este campo es requerido`,
    },
    lb: {
      message_required: `This field is required`,
    },
    ar: {
      message_required: `هذا الحقل اجباري`,
    },
    pt: {
      message_required: `Este campo é obrigatório`,
    },
  }

  const lang_format = {
    fr: {
      message_required: `Format de nombre incorrect`,
    },
    en: {
      message_required: `Incorrect number format`,
    },
    sw: {
      message_required: `Umekosea jinsi ya kuandika namba`,
    },
    za: {
      message_required: `Kabuyaŋiizey hantumyaŋey faỳanka-faỳanka`,
    },
    ha: {
      message_required: `Rubutun lambobi ya bambanta`,
    },
    es: {
      message_required: `Formato de número incorrecto`,
    },
    lb: {
      message_required: `Incorrect number format`,
    },
    ar: {
      message_required: `خطأ في صيغة الرقم`,
    },
    pt: {
      message_required: `Formato numérico incorreto`,
    },
  }

  const lang_max_length = {
    fr: {
      message_required: `9 caractères maximum autorisés`,
    },
    en: {
      message_required: `Maximum allowed characters are 9`,
    },
    sw: {
      message_required: `Mwisho ni tarakimu au herufi 9`,
    },
    za: {
      message_required: `Hantumiize yagga hinne no ga furo ne`,
    },
    ha: {
      message_required: `Harahi tara  kaɗay ake iya rubutawa a nan`,
    },
    es: {
      message_required: `Los caracteres máximos permitidos son 9`,
    },
    lb: {
      message_required: `Maximum allowed characters are 9`,
    },
    ar: {
      message_required: `الحد الاقصى للادخال ٩`,
    },
    pt: {
      message_required: `O máximo de caracteres permitidos é 9`,
    },
  }

  const lang_text_only = {
    fr: {
      message_required: `Entrer seulement du texte`,
    },
    en: {
      message_required: `Enter text only`,
    },
    sw: {
      message_required: `Ingiza herufi pekee`,
    },
    za: {
      message_required: `Zarma for Enter text only`,
    },
    ha: {
      message_required: `Rubuta matani kaɗay`,
    },
    es: {
      message_required: `Inserta solo texto`,
    },
    lb: {
      message_required: `Enter text only`,
    },
    ar: {
      message_required: `ادخال احرف/ كلمات فقط`,
    },
    pt: {
      message_required: `Insira apenas texto`,
    },
  }

  let errors = {}
  const letters = /^[a-zA-ZÀ-ÿ0-9-' \u0600-\u06FF]*$/

  if (data.name === "") {
    errors.name = lang_required[lang_code].message_required
  } else if (!data.name.match(letters)) {
    errors.name = lang_text_only[lang_code].message_required
  }

  if (data.establishment_date === "" && lang_code !== "ar" && lang_code !== "lb") {
    errors.establishment_date = lang_required[lang_code].message_required
  }

  // if (data.location === "") {
  //   errors.location = lang_required[lang_code].message_required;
  // }

  // if (!data.location.match(letters)) {
  //   errors.name = lang_text_only[lang_code].message_required;
  // }
  if (!data.share_value) {
    errors.share_value = lang_required[lang_code].message_required
  }

  else if (isNaN(data.share_value)) {
    errors.share_value = lang_format[lang_code].message_required
  }

  else if (data.share_value.length > 9) {
    errors.share_value = lang_max_length[lang_code].message_required
  }

  if (data.savings_cycle === "") {
    errors.savings_cycle = lang_required[lang_code].message_required
  }

  if (data.country === "") {
    errors.country = lang_required[lang_code].message_required
  }

  if (data.currency === "" && (lang_code === "ar" || lang_code === "lb")) {
    errors.currency = lang_required[lang_code].message_required
  }

  return {
    errors,
    isValid: isEmpty(errors),
  }
}
